// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const florges: PokeData = {
  "id": 671,
  "name": "florges",
  "height": 11,
  "weight": 100,
  "base_experience": 248,
  "types": [
    PokeType.FAIRY
  ],
  "api_moves": [
    "solar-beam",
    "petal-dance",
    "safeguard",
    "synthesis",
    "wish",
    "aromatherapy",
    "magical-leaf",
    "lucky-chant",
    "grass-knot",
    "petal-blizzard",
    "disarming-voice",
    "flower-shield",
    "grassy-terrain",
    "misty-terrain",
    "moonblast"
  ],
  "moves": [
    "solar-beam",
    "synthesis",
    "aromatherapy",
    "grassy-terrain",
    "misty-terrain",
    "moonblast",
    "hyper-voice",
    "spirit-break",
    "moonlight",
    "heal-bell",
    "guardian-bond",
    "mist-terrain",
    "dazzling-gleam"
  ],
  "evolution_chain": {
    "id": 344,
    "item": null,
    "species": [
      {
        "name": "flabebe",
        "order": 670,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "floette",
        "order": 671,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 669,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 19,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "florges",
        "order": 672,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 670,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "shiny-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 134,
    "speed": 107,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
